import { Country, EventInfo } from 'in-time-core';
import { Comparator } from './comparison-utils';

export function compareEventsByFeaturedFlag(
  a: EventInfo,
  b: EventInfo,
): number {
  if(a.classificationInfo.isFeatured && !b.classificationInfo.isFeatured) {
    return -1;
  }

  if(!a.classificationInfo.isFeatured && b.classificationInfo.isFeatured) {
    return 1;
  }

  return 0;
}

export function compareEventsByFeaturedScore(
  a: EventInfo,
  b: EventInfo,
): number {
  return b.classificationInfo.featuredScore - a.classificationInfo.featuredScore;
}

export function compareEventsByStartDate(
  a: EventInfo,
  b: EventInfo,
): number {
  return a.startDate.valueOf() - b.startDate.valueOf();
}

export function compareEventsByCountry(userCountry: Country): Comparator<EventInfo> {
  return (a, b) => {
    if(a.country === userCountry && b.country !== userCountry) {
      return -1;
    }

    if(a.country !== userCountry && b.country === userCountry) {
      return 1;
    }

    return 0;
  }
}
